import { chessDefinition } from "./chess";
import { connectFourDefinition } from "../connect-four";
import { hex4Definition } from "../hex";
import { go3Definition, go4Definition, go5Definition } from "../go";
import { GameRegistry } from "./registry";

export const gameRegistry = new GameRegistry()
  .register(chessDefinition)
  .register(connectFourDefinition)
  .register(hex4Definition)
  .register(go3Definition)
  .register(go4Definition)
  .register(go5Definition);
export const DEFAULT_GAME_ID = chessDefinition.gameId;
export const DEFAULT_VARIANT_ID = chessDefinition.variantId;

export { chessDefinition } from "./chess";
export { GameRegistry } from "./registry";
export type {
  AnyGameDefinition,
  BoardDimensions,
  GameControls,
  GameDefinition,
  GameEnvironment,
  GameRenderContext,
  GameRenderer,
  Player,
} from "./types";
